(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["hdr-nav"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    const toggle = event.target.closest('.hdr__nav-toggle');

    if (toggle) {
      const nav = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!nav) return;

      const isOpen = nav.classList.toggle('is-open');
      toggle.classList.toggle('is-active', isOpen);
      toggle.setAttribute('aria-expanded', isOpen);
      return;
    }

    const caret = event.target.closest('.hdr__nav-caret');

    if (caret) {
      event.preventDefault();
      caret.closest('.hdr__nav-item').classList.toggle('is-open');
      return;
    }

    const openNav = document.querySelector('.hdr__nav.is-open');

    if (openNav && !event.target.closest('.hdr__nav') && !event.target.closest('.hdr__nav-toggle')) {
      openNav.classList.remove('is-open');
      const relatedToggle = document.querySelector(`.hdr__nav-toggle[aria-controls="${openNav.id}"]`);
      if (relatedToggle) {
        relatedToggle.classList.remove('is-active');
        relatedToggle.setAttribute('aria-expanded', 'false');
      }
    }
  });
  } catch(e) { console.error(e); }
})();

})();
